/* eslint-disable react/destructuring-assignment */
import React, { useState, useContext } from "react";
import { string, bool, func } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import EcheqHeaderTicket from "pages/echeck/components/EcheqHeaderTicket";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import CustomData from "../../../_components/CustomData/CustomData";

const TransactionBody = (props) => {
    const { transaction } = useContext(TransactionContext);
    const { showMoreData, setShowMoreData, isDesktop } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const { data: echeckAction = {}, idTransaction = "", idTransactionStatus } = transaction;
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const { document = props.document, echeqList = props.echeqList } = echeckAction;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const echeq = echeqList[0];

    return (
        <div className="ticket__body echeq-endorse">
            <>
                <EcheqHeaderTicket
                    estado={echeq.finalStatus || echeq.estado}
                    caracter={echeq.cheque_caracter}
                    moneda={echeq.moneda}
                    monto={echeq.monto}
                    id={echeq.cheque_numero}
                    status={idTransactionStatus}
                    isDesktop={isDesktop}
                />
                <div className="view-more-data-button">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className="ticket-section">
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                <GridTable.Container className="ticket-gap">
                                    <GridTable.Data columnStart={1} rowStart={1}>
                                        <CustomData
                                            titleText="echecks.beneficiary"
                                            titleTextType="I18N"
                                            valueText={echeq.emisor_razon_social}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={2} alignY="flex-start">
                                        <CustomData
                                            titleText="echecks.document"
                                            titleTextType="I18N"
                                            valueText={document}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={1}>
                                        <CustomData
                                            titleText="echecks.amount"
                                            titleTextType="I18N"
                                            valueText={echeq.monto}
                                            valueTextType={echeq.emisor_moneda}
                                        />{" "}
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={2}>
                                        <CustomData
                                            titleText="echecks.currency"
                                            titleTextType="I18N"
                                            valueText={echeq?.moneda}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </div>{" "}
                        <TransactionSign
                            isSmall
                            creationTime
                            hasVaucher
                            isDesktop={isDesktop}
                            noDate={isPending}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        </div>
    );
};

TransactionBody.propTypes = {
    isDesktop: bool,
    showMoreData: bool,
    setShowMoreData: func,
    document: string,
};

TransactionBody.defaultProps = {
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
    document: "",
};

export default TransactionBody;
